var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPreviousDefault(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_197_4",
    "data-name": "Component 197 \\u2013 4",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1089",
    "data-name": "Ellipse 1089",
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#1c1b3a"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_49957",
    "data-name": "Path 49957",
    d: "M16.559,21.178a1.417,1.417,0,0,0,1.015-2.415l-.009-.009-4.69-4.662L17.381,9.4a1.418,1.418,0,0,0-2-2.007l-.009.009L9.9,13.072a1.418,1.418,0,0,0,0,1.984l5.668,5.669a1.414,1.414,0,0,0,.992.453",
    transform: "translate(6.506 6.016)",
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviousDefault);
export default __webpack_public_path__ + "static/media/previous_default.cd5c8f255a2da1693c7fa0a3efa60ea3.svg";
export { ForwardRef as ReactComponent };